<div class="panel-body glebas-tab">
  <table class="table table-striped table-condensed">
    <thead>
      <tr>
        <th>Talhão</th>
        <th>TS</th>
        <th>Área (ha)</th>
        <th>Cultivar</th>
        <th ng-if="!recomendacaoSemeadura.data.cobertura">Densidade (pl/ha)</th>
        <th ng-if="!recomendacaoSemeadura.isCulturaPorUnidade && !recomendacaoSemeadura.data.cobertura">PMS (gr)</th>
        <th ng-if="!recomendacaoSemeadura.data.cobertura">PG (%)</th>
        <th ng-if="recomendacaoSemeadura.data.cobertura">Dose (kg/ha)</th>
        <th>Ciclo (dias)</th>
        <th>Data Início</th>
        <th>Data Fim</th>
        <th>Tempo (dias)</th>
        <th></th>
      </tr>
    </thead>
    <tfoot ng-hide="recomendacaoSemeadura.isEditingGleba()">
      <tr>
        <td class="gleba-field">
          <div class="form-group">
            <select ng-model="recomendacaoSemeadura.tempGleba.gleba" class="form-control" ng-options="gleba as recomendacaoSemeadura.glebaDescricao(gleba) for gleba in recomendacaoSemeadura.data.propriedade.glebas | orderBy:'descricao'">
              <option value="">Talhão</option>
            </select>
          </div>
        </td>
        <td class="ts-field">
          <div class="form-group">
            <select ng-model="recomendacaoSemeadura.tempGleba.ts"
                    class="form-control"
                    ng-change="recomendacaoSemeadura.changeCultura(recomendacaoSemeadura.data.cultura, recomendacaoSemeadura.tempGleba.ts)">
              <option value="none">Nenhum</option>
              <option value="ts">TS</option>
              <option value="tsi">TSi</option>
            </select>
          </div>
        </td>
        <td class="area-field">
          <div class="form-group">
            <input type="number" ng-model="recomendacaoSemeadura.tempGleba.area_aplicada" class="form-control" auto-step min="0" placeholder="Área" uib-tooltip="Área aplicada maior que área total da gleba!" tooltip-is-open="recomendacaoSemeadura.areaExceeded()" tooltip-placement="bottom" tooltip-trigger="none">
          </div>
        </td>
        <td class="cultura-field">
          <div class="form-group no-margin">
            <ui-select ng-model="recomendacaoSemeadura.tempGleba.cultivar" theme="bootstrap" ng-disabled="!recomendacaoSemeadura.tempGleba.ts">
              <ui-select-match placeholder="Cultivar" allow-clear="false">{{$select.selected.descricao | characters:30}}</ui-select-match>
              <ui-select-choices repeat="cultivar in recomendacaoSemeadura.cultivares"
                                 refresh="recomendacaoSemeadura.searchCultivares($select)"
                                 refresh-delay="300">
                <div ng-bind-html="cultivar.descricao | highlight: $select.search"></div>
                <span ng-show="$root.permissions.estoque.canViewStock && $root.parametros.tem_controle_de_estoque">
                  <small ng-bind-html="'Físico: ' + (cultivar.saldo_fisico | number:4) + ' ' + (cultivar.unidade.abreviatura)"></small><br>
                  <small ng-bind-html="'Em Uso: ' + (cultivar.saldo_em_uso | number:4) + ' ' + (cultivar.unidade.abreviatura)"></small><br>
                  <small ng-bind-html="'A Receber: ' + (cultivar.saldo_receber | number:4) + ' ' + (cultivar.unidade.abreviatura)"></small>
                </span>
              </ui-select-choices>
            </ui-select>
          </div>
        </td>
        <td class="densidade-field" ng-if="!recomendacaoSemeadura.data.cobertura">
          <div class="form-group">
            <input type="number" ng-model="recomendacaoSemeadura.tempGleba.densidade" class="form-control" min="0" placeholder="Densidade">
          </div>
        </td>
        <td class="pms-field" ng-if="!recomendacaoSemeadura.isCulturaPorUnidade && !recomendacaoSemeadura.data.cobertura">
          <div class="form-group">
            <input type="number" ng-model="recomendacaoSemeadura.tempGleba.pms" class="form-control" min="0" step="0.01" placeholder="PMS">
          </div>
        </td>
        <td class="pg-field" ng-if="!recomendacaoSemeadura.data.cobertura">
          <div class="form-group">
            <input type="number" ng-model="recomendacaoSemeadura.tempGleba.pg" class="form-control" max="100" min="0" step="1" placeholder="PG">
          </div>
        </td>
        <td class="dose-field" ng-if="recomendacaoSemeadura.data.cobertura">
          <div class="form-group">
            <input type="number" ng-model="recomendacaoSemeadura.tempGleba.dose" class="form-control" min="0" step="0.01" placeholder="Dose (kg/ha)">
          </div>
        </td>
        <td class="ciclo-field">
          <div class="form-group">
            <input type="number" ng-model="recomendacaoSemeadura.tempGleba.ciclo" class="form-control" min="0" step="1" placeholder="Ciclo">
          </div>
        </td>
        <td class="inicio-field">
          <div class="form-group" ng-if="!recomendacaoSemeadura.isEditingGleba()">
            <div class="input-group">
              <input type="text" class="form-control white-bg" readonly datepicker-options="recomendacaoSemeadura.datePickerOptions" placeholder="Data início"
                uib-datepicker-popup="{{recomendacaoSemeadura.popupData.format}}" ng-model="recomendacaoSemeadura.tempGleba.data_inicio"
                is-open="recomendacaoSemeadura.popupData.openedDataInicio" show-button-bar="false" datepicker-append-to-body="true"
                ng-change="recomendacaoSemeadura.calcDuracao(recomendacaoSemeadura.tempGleba)">
              <span class="input-group-btn">
                <button type="button" class="btn btn-default" ng-click="recomendacaoSemeadura.openPopupData('openedDataInicio')">
                  <i class="glyphicon glyphicon-calendar"></i>
                </button>
              </span>
            </div>
          </div>
        </td>
        <td class="inicio-field">
          <div class="form-group" ng-if="!recomendacaoSemeadura.isEditingGleba() && !!recomendacaoSemeadura.tempGleba.area_aplicada">
            <div class="input-group">
              <input type="text" class="form-control white-bg" readonly datepicker-options="recomendacaoSemeadura.datePickerOptions" placeholder="Data Final"
                uib-datepicker-popup="{{recomendacaoSemeadura.popupData.format}}" ng-model="recomendacaoSemeadura.tempGleba.data_fim_max"
                is-open="recomendacaoSemeadura.popupData.openedDataFim" show-button-bar="false" datepicker-append-to-body="true"
                ng-change="recomendacaoSemeadura.validateDataFim(recomendacaoSemeadura.tempGleba)">
              <span class="input-group-btn">
                <button type="button" class="btn btn-default" ng-click="recomendacaoSemeadura.openPopupData('openedDataFim')">
                  <i class="glyphicon glyphicon-calendar"></i>
                </button>
              </span>
            </div>
          </div>
        </td>        
        <td colspan="2">
          <button type="button" class="btn btn-link" ng-click="recomendacaoSemeadura.saveGleba()" ng-disabled="recomendacaoSemeadura.addGlebaDisabled()">Salvar</button>
          <button type="button" class="btn btn-link text-warning" ng-click="recomendacaoSemeadura.cancelEditGleba()" ng-show="recomendacaoSemeadura.editGlebaId !== false">Cancelar</button>
        </td>
      </tr>
    </tfoot>
    <tbody>
      <tr ng-repeat="gleba in recomendacaoSemeadura.sortedGlebas() track by gleba._id" ng-style="{'background-color': gleba._edit ? '#fcf8e3' : ''}">
        <td>
          <span ng-hide="gleba._edit">{{gleba.gleba.descricao}}</span>
          <div class="form-group" ng-show="gleba._edit">
            <label class="control-label">Talhão</label>
            <select ng-model="recomendacaoSemeadura.tempGleba.gleba" class="form-control" ng-options="gleba as recomendacaoSemeadura.glebaDescricao(gleba) for gleba in recomendacaoSemeadura.data.propriedade.glebas | orderBy:'descricao'">
              <option value="">Talhão</option>
            </select>
          </div>
        </td>
        <td>
            <span ng-hide="gleba._edit">{{gleba.ts == 'none' ? 'Nenhum' : gleba.ts | uppercase}}</span>
            <div class="form-group" ng-show="gleba._edit">
                <label class="control-label">TS</label>
              <select ng-model="recomendacaoSemeadura.tempGleba.ts"
                      class="form-control"
                      ng-change="recomendacaoSemeadura.changeCultura(recomendacaoSemeadura.data.cultura, recomendacaoSemeadura.tempGleba.ts)">
                <option value="none">Nenhum</option>
                <option value="ts">TS</option>
                <option value="tsi">TSi</option>
              </select>
            </div>
        </td>
        <td>
            <span ng-hide="gleba._edit">{{gleba.area_aplicada | number:2}}ha</span>
            <div class="form-group" ng-show="gleba._edit">
              <label class="control-label">Área</label>
              <input type="number" ng-model="recomendacaoSemeadura.tempGleba.area_aplicada" class="form-control" auto-step min="0" placeholder="Área" uib-tooltip="Área aplicada maior que área total da gleba!" tooltip-is-open="recomendacaoSemeadura.areaExceeded()" tooltip-placement="bottom" tooltip-trigger="none">
            </div>
        </td>
        <td class="cultivar-edit">
            <span ng-hide="gleba._edit">{{gleba.cultivar.descricao}}</span>
            <div class="form-group" ng-show="gleba._edit">
              <label class="control-label">Cultivar</label>
              <ui-select ng-model="recomendacaoSemeadura.tempGleba.cultivar" theme="bootstrap" ng-disabled="!recomendacaoSemeadura.tempGleba.ts">
                <ui-select-match placeholder="Cultivar" allow-clear="false">{{$select.selected.descricao | characters:30}}</ui-select-match>
                <ui-select-choices repeat="cultivar in recomendacaoSemeadura.cultivares"
                                   refresh="recomendacaoSemeadura.searchCultivares($select)"
                                   refresh-delay="300">
                  <div ng-bind-html="cultivar.descricao | highlight: $select.search"></div>
                  <span ng-show="$root.permissions.estoque.canViewStock && $root.parametros.tem_controle_de_estoque">
                    <small ng-bind-html="'Físico: ' + (cultivar.saldo_fisico | number:4) + ' ' + (cultivar.unidade.abreviatura)"></small><br>
                    <small ng-bind-html="'Em Uso: ' + (cultivar.saldo_em_uso | number:4) + ' ' + (cultivar.unidade.abreviatura)"></small><br>
                    <small ng-bind-html="'A Receber: ' + (cultivar.saldo_receber | number:4) + ' ' + (cultivar.unidade.abreviatura)"></small>
                  </span>
                </ui-select-choices>
              </ui-select>
            </div>
        </td>
        <td ng-if="!recomendacaoSemeadura.data.cobertura">
          <span ng-hide="gleba._edit">{{gleba.densidade | number}}</span>
          <div class="form-group" ng-show="gleba._edit">
            <label class="control-label">Densidade</label>
            <input type="number" ng-model="recomendacaoSemeadura.tempGleba.densidade" class="form-control" min="0" placeholder="Densidade">
          </div>
        </td>
        <td ng-if="!recomendacaoSemeadura.isCulturaPorUnidade && !recomendacaoSemeadura.data.cobertura">
          <span ng-hide="gleba._edit">{{gleba.pms | number}}</span>
          <div class="form-group" ng-show="gleba._edit">
            <label class="control-label">PMS</label>
            <input type="number" ng-model="recomendacaoSemeadura.tempGleba.pms" class="form-control" min="0" step="0.01" placeholder="PMS">
          </div>
        </td>
        <td ng-if="!recomendacaoSemeadura.data.cobertura" colspan="{{ gleba._edit ? 2 : 1 }}">
          <span ng-hide="gleba._edit">{{gleba.pg | number}}</span>
          <div class="form-group" ng-show="gleba._edit">
            <label class="control-label">PG</label>
            <input type="number" ng-model="recomendacaoSemeadura.tempGleba.pg" class="form-control" max="100" min="0" step="1" placeholder="PG">
          </div>
        </td>
        <td ng-if="recomendacaoSemeadura.data.cobertura">
          <span ng-hide="gleba._edit">{{gleba.dose | number:2}} kg/ha</span>
          <div class="form-group" ng-show="gleba._edit">
            <label class="control-label">Dose</label>
            <input type="number" ng-model="recomendacaoSemeadura.tempGleba.dose" class="form-control" min="0" step="0.01" placeholder="Dose (kg/ha)">
          </div>
        </td>
        <td>
          <span ng-hide="gleba._edit">{{gleba.ciclo | number}}</span>
          <div class="form-group" ng-show="gleba._edit">
            <label class="control-label">Ciclo</label>
            <input type="number" ng-model="recomendacaoSemeadura.tempGleba.ciclo" class="form-control" min="0" step="1" placeholder="Ciclo">
          </div>
        </td>
        <td>
          <span ng-hide="gleba._edit">{{gleba.data_inicio | date:'dd/MM'}}</span>
          <div class="form-group" ng-if="gleba._edit">
            <label class="control-label">Data Início</label>
            <div class="input-group">
              <input type="text" class="form-control white-bg" readonly datepicker-options="recomendacaoSemeadura.datePickerOptions" placeholder="Data início"
                uib-datepicker-popup="{{recomendacaoSemeadura.popupData.format}}" ng-model="recomendacaoSemeadura.tempGleba.data_inicio"
                is-open="recomendacaoSemeadura.popupData.openedDataInicio" show-button-bar="false" datepicker-append-to-body="true"
                ng-change="recomendacaoSemeadura.calcDuracao(recomendacaoSemeadura.tempGleba)">
              <span class="input-group-btn">
                <button type="button" class="btn btn-default" ng-click="recomendacaoSemeadura.openPopupData('openedDataInicio')">
                  <i class="glyphicon glyphicon-calendar"></i>
                </button>
              </span>
            </div>
          </div>
        </td>
        <td> 
          <span ng-hide="gleba._edit">{{gleba.data_fim_min | date:'dd/MM'}} a {{gleba.data_fim_max | date:'dd/MM'}}</span>
          <div class="form-group" ng-if="gleba._edit">
            <label class="control-label">Data Fim</label>
            <div class="input-group">
              <input type="text" class="form-control white-bg" readonly datepicker-options="recomendacaoSemeadura.datePickerOptions" placeholder="Data Fim"
                uib-datepicker-popup="{{recomendacaoSemeadura.popupData.format}}" ng-model="recomendacaoSemeadura.tempGleba.data_fim_max"
                is-open="recomendacaoSemeadura.popupData.openedDataFim" show-button-bar="false" datepicker-append-to-body="true"
                ng-change="recomendacaoSemeadura.validateDataFim(recomendacaoSemeadura.tempGleba)">
              <span class="input-group-btn">
                <button type="button" class="btn btn-default" ng-click="recomendacaoSemeadura.openPopupData('openedDataFim')">
                  <i class="glyphicon glyphicon-calendar"></i>
                </button>
              </span>
            </div>
          </div>
        </td>
        <td ng-hide="gleba._edit">{{gleba.duracao_min | number:2}} a {{gleba.duracao_max | number:2}}</td>
        <td>
          <div ng-hide="gleba._edit" class="nowrap">
            <button type="button" class="btn btn-link text-info" ng-click="recomendacaoSemeadura.editGleba(gleba)" ng-show="recomendacaoSemeadura.data.status == 'rascunho'"><i class="fa fa-edit"></i></button>
            <button type="button" class="btn btn-link text-danger" ng-click="recomendacaoSemeadura.deleteGleba(gleba)"><i class="fa fa-trash"></i></button>
          </div>
          <div ng-show="gleba._edit" class="form-group">
            <label class="control-label">&nbsp;</label>
            <div class="nowrap">
              <button type="button" class="btn btn-link" ng-click="recomendacaoSemeadura.saveGleba()" ng-disabled="recomendacaoSemeadura.addGlebaDisabled()" uib-tooltip="Salvar"><i class="fa fa-check"></i></button>
              <button type="button" class="btn btn-link text-warning" ng-click="recomendacaoSemeadura.cancelEditGleba()" ng-show="recomendacaoSemeadura.editGlebaId !== false" uib-tooltip="Cancelar"><i class="fa fa-close"></i></button>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
